class BundleBuilder extends HTMLElement {
  constructor() {
    super();

    // Set the data
    this.bag = {
      items: [],
      subtotal: 0,
      quantity: 0,
    };
    this.elements = {
      addToCartButton: this.querySelector(".js-bundle-builder__add-to-cart"),
      ctas: this.querySelectorAll(".js-bundle-builder__card-cta"),
      modalSubmitButton: this.querySelector(".js-bundle-builder__modal-submit"),
      modalBackButtons: this.querySelectorAll(
        ".js-bundle-builder__modal-back-button"
      ),
      modalSlides: this.querySelectorAll(".js-bundle-builder__modal-slide"),
      modalNextButton: this.querySelector(".js-bundle-builder__modal-next"),
      quickViewToggles: this.querySelectorAll(".js-quick-view-button"),
    };

    // Add options from liquid
    this.options = bundleBuilder.options;
    this.strings = bundleBuilder.strings;
    this.assets = { cartImage: this.dataset.cartImage };

    // Set bag item placeholder
    this.placeholder = this.querySelectorAll(
      ".js-bundle-builder__placeholder"
    )[0].cloneNode(true);

    // Set bag item template
    this.initialbagItemTemplate = this.querySelector(
      ".js-bundle-builder__bag-item-template"
    );
    this.bagItemTemplate = this.initialbagItemTemplate.cloneNode(true);
    this.initialbagItemTemplate.remove();

    // Count the total items allowed in bag
    this.placeholderCountOnLoad = Array.from(
      this.querySelectorAll(".js-bundle-builder__placeholder")
    ).length;

    // Set the visual bag
    this.visualBag = this.querySelector(".js-bundle-builder__bag");

    // Set cart
    this.cart = document.querySelector("cart-drawer");

    // Add event listeners to CTAs
    this.addEventListenersToCtas(this.elements.ctas);
    // Set the base event listeners
    this._createEventListeners();

    // Populate from local storage if available
    const localStorage = this.getLocalStorage();
    if (localStorage) {
      const bagFromStorage = localStorage[this.getBagId()];
      if (bagFromStorage) {
        this.populateFromStorage(bagFromStorage);
      }
    }

    // Update totals (total price, quantity etc)
    this.updateTotals();

    // Remove links from cards
    this.querySelectorAll(".js-bundle-builder-link-remove").forEach((item) => {
      item.removeAttribute("href");
      item.style.cursor = "default";
    });
  }

  // Add click events
  __addClickEventListener(element, callback) {
    element.addEventListener("click", (event) => {
      callback(event);
    });
  }

  __addClickEventListenerToAll(array, callback) {
    array.forEach((element) => {
      element.addEventListener("click", (event) => {
        callback(event);
      });
    });
  }

  // Create event listeners
  _createEventListeners() {
    this.__addClickEventListener(
      this.elements.modalSubmitButton,
      this.addToCart.bind(this)
    );
    this.__addClickEventListener(
      this.elements.addToCartButton,
      this.openPreCartModal.bind(this)
    );
    this.__addClickEventListener(
      this.elements.modalNextButton,
      this.setModalSlide.bind(this, 2)
    );
    this.__addClickEventListenerToAll(
      this.elements.modalBackButtons,
      this.closePreCartModal.bind(this)
    );
  }

  // Add event listeners to item CTAs
  addEventListenersToCtas(elements) {
    elements.forEach((button) => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        const item = {
          id: Number(event.target.dataset.productId),
          quantity: 1,
          title: event.target.dataset.title,
          image: event.target.dataset.image,
          price: Number(event.target.dataset.price),
        };
        this.processItemAddition(item);

        const modal = event.target.closest("quick-add-modal");
        if (modal) modal.hide();
      });
    });
  }

  addToBag(object) {
    const id = Number(object.id);
    const title = object.title;
    const image = object.image;
    const price = Number(object.price);
    const item = {
      id: id,
      title: title,
      image: image,
      price: price,
    };

    this.bag.items.push(item);
    this.bag.quantity += 1;
    this.updateLocalStorage();
    this.updateTotals();
  }

  addToCart(event) {
    // Set giftee + message
    const gifteeInput = this.querySelector(
      ".js-bundle-builder__modal-input--name"
    );

    const giftMessage =
      this.querySelector(".js-bundle-builder__modal-input--message").value ||
      "No gift message added";

    // Check giftee
    if (!gifteeInput.value) {
      gifteeInput.classList.add("shake");
      setTimeout(() => {
        gifteeInput.classList.remove("shake");
      }, 1000);
      return;
    }

    // Change button
    event.target.textContent = "Adding...";
    event.target.setAttribute("aria-disabled", true);
    event.target.style.pointerEvents = "none";

    // Check if cart requires cleanse
    let cartRequiresCleanse = false;
    const localStorage = this.getLocalStorage();
    if (localStorage) {
      const bagFromStorage = localStorage[this.getBagId()];
      if (bagFromStorage) {
        if (bagFromStorage.addedToCart) {
          cartRequiresCleanse = true;
        }
      }
    }

    // Cleanse cart of current bag
    if (cartRequiresCleanse) {
      fetch(window.Shopify.routes.root + "cart.js")
        .then((response) => response.text())
        .then((state) => {
          const json = JSON.parse(state);
          const itemsToRemove = [];
          json.items.forEach((item) => {
            if (item.properties) {
              if (Number(item.properties._gift_box_id) >= 0) {
                itemsToRemove.push(item.key);
              }
            }
          });

          if (itemsToRemove.length) {
            const config = fetchConfig("javascript");
            config.headers["X-Requested-With"] = "XMLHttpRequest";
            config.headers["Content-Type"] = "application/json";
            config.method = "POST";
            const obj = {};
            itemsToRemove.forEach((item) => {
              return (obj[`${item}`] = 0);
            });
            config.body = JSON.stringify({
              updates: obj,
            });
            fetch(`${routes.cart_update_url}`, config)
              .then((response) => response.text())
              .then((state) => {
                const json = JSON.parse(state);
                this.processCart(event);
              })
              .catch((e) => {
                alert(e);
                event.target.setAttribute("aria-disabled", true);
                event.target.textContent = "Error";
              });
          } else {
            this.processCart(event);
          }
        })
        .catch((e) => {
          alert(e);
          event.target.setAttribute("aria-disabled", true);
          event.target.textContent = "Error";
        });
    } else {
      this.processCart(event);
    }
  }

  addToVisualBag(item) {
    // Create the clone
    const clone = this.bagItemTemplate.cloneNode(true);
    clone.querySelector("[data-image]").src = item.image;
    clone.dataset.id = item.id;
    clone.classList.remove("js-bundle-builder__bag-item-template");
    clone.classList.remove("hidden");

    // Set arrays from placeholders and visual bag items
    const placeholders = Array.from(
      this.querySelectorAll(".js-bundle-builder__placeholder")
    );
    const bagItems = Array.from(
      this.querySelectorAll(".bundle-builder__bag-item")
    );

    // If bag is empty insert as first item else insert after last item
    const lastbagItem = bagItems[bagItems.length - 1];
    const firstPlaceholder = placeholders[0];
    // If bag is empty
    if (placeholders.length === this.placeholderCountOnLoad) {
      // Add item at start of bag
      this.visualBag.insertBefore(clone, this.visualBag.firstChild);
    }
    // If bag is not empty
    else {
      // Add after last bag item
      this.visualBag.insertBefore(clone, lastbagItem.nextSibling);
    }
    // Remove a placeholder (The first in the found list)
    if (firstPlaceholder) {
      firstPlaceholder.parentNode.removeChild(firstPlaceholder);
    }

    const updatedBagItems = Array.from(
      this.querySelectorAll(".bundle-builder__bag-item")
    );
    const insertedItem = updatedBagItems[updatedBagItems.indexOf(clone)];
    const button = insertedItem.querySelector(
      ".js-bundle-builder__bag-remove-button"
    );
    button.addEventListener("click", (event) => {
      this.processItemRemoval(event);
    });
  }

  closePreCartModal() {
    const modal = this.querySelector(".js-bundle-builder__modal");
    modal.classList.toggle("hidden");
  }

  getBagId() {
    if (this.bag.id) return this.bag.id;

    const queryParams = new URLSearchParams(window.location.search);
    const idFromParam = queryParams.get("bagId");

    // If local storage is available
    if (this.getLocalStorage()) {
      // Return id from param
      if (idFromParam) {
        if (this.getLocalStorage()[idFromParam]) {
          // Set isSavedBag
          this.bag["isSavedBag"] = true;
          // Process URL parameters
          this.processUrlParams();
          // Return
          this.bag.id = idFromParam;
        }
      }

      // Return id of first bag not added to cart
      const addToCartStatuses = this.getLocalStorage().map(
        ({ addedToCart }) => {
          return addedToCart || false;
        }
      );
      if (addToCartStatuses.includes(false)) {
        this.bag.id = addToCartStatuses.indexOf(false);
      }

      // Else return next available ID
      const bagsAddedToCart = this.getLocalStorage().filter(
        (item) => item.addedToCart
      );
      if (bagsAddedToCart.length) {
        this.bag.id = bagsAddedToCart.length + 1;
      }
    }

    // Or return 0
    this.bag.id = 0;

    return this.bag.id;
  }

  getBagItem(bag, id) {
    switch (bag) {
      case this.bag:
        return this.bag.items.find((item) => Number(item.id) === Number(id));
      case this.visualBag:
        return this.getVisualBagItems().find(
          (item) => Number(item.dataset.id) === Number(id)
        );
      default:
        return null;
    }
  }

  getCtaFromId(id) {
    const ctas = Array.from(
      this.querySelectorAll(".js-bundle-builder__card-cta")
    );
    const found = ctas.find(
      (item) => Number(item.dataset.productId) === Number(id)
    );

    return found;
  }

  getCurrencySymbol() {
    switch (Shopify.currency.active) {
      case "GB":
        return "£";
      case "EUR":
        return "€";
      default:
        return "£";
    }
  }

  getBagItemQuantity(id) {
    const matchingItems = this.bag.items.filter((item) => item.id === id);
    return matchingItems.length;
  }

  getLocalStorage() {
    return localStorage.getItem("bundleBuilder")
      ? JSON.parse(localStorage.getItem("bundleBuilder"))
      : false;
  }

  getVisualBagItems() {
    return Array.from(
      this.visualBag.querySelectorAll(".bundle-builder__bag-item")
    );
  }

  isLoading(item) {
    item.classList.add("loading");
    item.setAttribute("aria-disabled", true);
    item.querySelector(".loading-overlay__spinner").classList.remove("hidden");
  }

  // Triggered from quick-add.js
  modalReady(modal) {
    modal
      .querySelector(".js-bundle-builder__card-quick-view-cta")
      .addEventListener("click", (event) => {
        event.preventDefault();
        const modalElement = event.target.closest(".quick-add-modal");
        const select = modalElement.querySelector(
          ".js-bundle-builder__product-select"
        );
        const button = modalElement.querySelector(
          ".js-bundle-builder__card-quick-view-cta"
        );
        const dataElement = select
          ? select.options[select.selectedIndex]
          : button;

        const item = {
          id: Number(dataElement.dataset.productId),
          quantity: 1,
          title: dataElement.dataset.title,
          image: dataElement.dataset.image,
          price: Number(dataElement.dataset.price),
        };
        this.processItemAddition(item);

        const modal = event.target.closest("quick-add-modal");
        if (modal) modal.hide();
      });
    this.toggleCTABlock();
  }

  openPreCartModal() {
    this.setModalSlide(1);
    const modal = this.querySelector(".js-bundle-builder__modal");
    let modalContents = this.querySelector(
      ".js-bundle-builder__modal-content-wrapper"
    );

    // Populate giftee and gift message if available
    const gifteeInput = this.querySelector(
      ".js-bundle-builder__modal-input--name"
    );
    const giftMessageInput = this.querySelector(
      ".js-bundle-builder__modal-input--message"
    );
    if (this.bag.giftee) {
      gifteeInput.value = this.bag.giftee;
    }
    if (this.bag.giftMessage) {
      giftMessageInput.value = this.bag.giftMessage;
    }

    this.totals = this.bag.items.reduce((acc, cur) => {
      cur.quantity = 1;
      const duplicate = acc.find((item) => item.id === cur.id);
      if (duplicate) {
        duplicate.price += cur.price;
        duplicate.quantity++;
      } else {
        acc.push(cur);
      }
      return acc;
    }, []);

    const template = modalContents.querySelector(
      ".js-bundle-builder__modal-item-template"
    );

    if (!this.modalTemplateClone) {
      this.modalTemplateClone = template.cloneNode(true);
    }

    modalContents.innerHTML = "";

    this.totals.forEach((item) => {
      const clone = this.modalTemplateClone.cloneNode(true);
      const titleElement = clone.querySelector("[data-title]");
      const title = item.title.replace(" - ", "</br>");
      titleElement.innerHTML = `${item.quantity}x ${title}`;

      const priceElement = clone.querySelector("[data-price]");
      priceElement.textContent = `£${item.price}`;

      const removeElement = clone.querySelector("[data-id]");
      removeElement.dataset.id = item.id;
      removeElement.dataset.quantity = item.quantity;

      clone.classList.remove("hidden");
      clone.classList.remove("js-bundle-builder__modal-item-template");
      modalContents.innerHTML += clone.outerHTML;
    });

    const clone = this.modalTemplateClone.cloneNode(true);
    clone.classList.remove("hidden");
    clone.classList.remove("js-bundle-builder__modal-item-template");
    clone.innerHTML = `<h4>Total</h4><h4>£<span class="js-bundle-builder__modal-total">${this.bag.subtotal}<span></h4>`;
    modalContents.innerHTML += clone.outerHTML;

    // Set click listener on remove buttons
    const removeButtons = Array.from(
      this.querySelectorAll(".js-bundle-builder__modal-remove-button")
    );
    removeButtons.forEach((item) => {
      item.addEventListener("click", (event) => {
        this.processModalRemoveButtonClick(event);
      });
    });

    modal.classList.toggle("hidden");
  }

  populateFromStorage(bagFromStorage) {
    if (bagFromStorage.addedToCart) {
      this.bag.addedToCart = true;
    }
    if (bagFromStorage.giftMessage) {
      this.bag.giftMessage = bagFromStorage.giftMessage;
    }
    if (bagFromStorage.giftee) {
      this.bag.giftee = bagFromStorage.giftee;
    }
    bagFromStorage.items.forEach((item) => {
      this.processItemAddition(item);
    });
  }

  processCart(event) {
    // Create the fetch
    const config = fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    config.headers["Content-Type"] = "application/json";
    config.method = "POST";
    const gifteeInput = this.querySelector(
      ".js-bundle-builder__modal-input--name"
    );
    const giftMessage =
      this.querySelector(".js-bundle-builder__modal-input--message").value ||
      "No gift message added";

    // Add giftee and gift message
    this.updateLocalStoreProperty("giftee", gifteeInput.value);
    this.updateLocalStoreProperty("giftMessage", giftMessage);

    config.body = JSON.stringify({
      sections: this.cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
      items: this.totals.map(({ id, quantity }) => ({
        id,
        quantity,
        properties: {
          _giftee: gifteeInput.value,
          _gift_message: giftMessage,
          _gift_box_id: this.getBagId(),
          _cart_image: this.assets.cartImage,
        },
      })),
    });

    // The fetch and responses
    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.items) {
          this.updateLocalStoreProperty("addedToCart", true);
          window.location = "/cart";
        } else {
          event.target.setAttribute("aria-disabled", true);
          event.target.textContent = "Error";
          return;
        }
      })
      .catch((e) => {
        alert(e);
      });
  }

  processItemAddition(item) {
    const cta = this.getCtaFromId(item.id);
    this.addToBag(item);
    this.addToVisualBag(item);
    this.updateCTAtext(cta);
    this.toggleCTABlock();
  }

  processItemRemoval(event, parsedId = false) {
    const button = event.target;
    const bagItems = Array.from(this.visualBag.children);
    const id =
      parsedId ||
      Number(button.closest(".bundle-builder__bag-item").dataset.id);
    const matchingBagItem = bagItems.find(
      (item) => Number(item.dataset.id) === id
    );
    const item = button.closest(".bundle-builder__bag-item") || matchingBagItem;

    const newQuantity = this.getBagItemQuantity(id) - 1;

    this.removeFromBag(id);
    this.updateLocalStorage();
    this.updateTotals();
    this.toggleCTABlock();

    // Pass matching card CTA to updateCTAtext
    const cta = this.getCtaFromId(id);
    this.updateCTAtext(cta, newQuantity);

    // Remove the item from the visual bag/modal
    item.remove();

    // Add a placeholder as last item
    const lastbagItem = bagItems[bagItems.length - 1];
    const clone = this.placeholder.cloneNode(true);
    this.visualBag.insertBefore(clone, lastbagItem.nextSibling);
  }

  processModalRemoveButtonClick(event) {
    event.target.closest(".bundle-builder__modal-item-template").remove();
    const quantity = Number(event.target.dataset.quantity);
    for (let i = 0; i < quantity; i++) {
      this.processItemRemoval(event, Number(event.target.dataset.id));
    }
  }

  processUrlParams() {
    const queryParams = new URLSearchParams(window.location.search);
    const bundleParam = queryParams.get("bagId");
    if (bundleParam) {
      queryParams.delete("bagId");
      history.pushState(
        null,
        "",
        `${window.location.origin}${
          window.location.pathname
        }?${queryParams.toString()}`
      );
    }
  }

  removeFromBag(id) {
    const found = this.getBagItem(this.bag, id);
    const index = this.bag.items.indexOf(found);
    this.bag.items.splice(index, 1);
    this.bag.quantity -= 1;
  }

  setBagVisibility(direction) {
    switch (direction) {
      case "open":
        this.visualBag.classList.add("bundle-builder__bag--is-open");
        break;
      case "close":
        this.visualBag.classList.remove("bundle-builder__bag--is-open");
        break;
    }
  }

  setModalSlide(slideNumber) {
    const slides = Array.from(this.elements.modalSlides);
    slides.forEach((item) => {
      item.classList.add("hidden");
    });
    const found = slides.find(
      (item) => Number(item.dataset.slide) === slideNumber
    );
    found.classList.remove("hidden");
  }

  setRemoveButtonEventListener(button) {
    button.addEventListener("click", (event) => {
      this.processItemRemoval(event);
    });
  }

  toggleCTABlock() {
    // Disable CTAs if this is the last item to be added
    const state = this.bag.quantity === this.options.maxItems;
    this.elements.ctas.forEach((item) => {
      item.setAttribute("aria-disabled", state);
    });
    document
      .querySelectorAll(".js-bundle-builder__card-quick-view-cta")
      .forEach((item) => {
        item.setAttribute("aria-disabled", state);
      });
  }

  updateCTAtext(cta, updatedQuantity = false) {
    if (!cta) return;
    const id = Number(cta.dataset.productId);
    const quantity = updatedQuantity || this.getBagItemQuantity(id);
    const text = quantity
      ? quantity + " " + this.strings.inBag
      : this.strings.addToBagText;
    cta.textContent = text;
    cta.addEventListener("mouseenter", (event) => {
      cta.textContent = this.strings.addAgainText;
    });
    cta.addEventListener("mouseleave", (event) => {
      cta.textContent = text;
    });
  }

  updateLocalStorage() {
    const localStore = this.getLocalStorage() || [];
    // If local storage is set
    if (this.getLocalStorage()) {
      // If local storage has a bag for this ID
      if (localStore[this.getBagId()]) {
        // Set local store for this ID to the current bag
        localStore[this.getBagId()] = this.bag;
      } else {
        // Else add the current bag to end of the array
        localStore.push(this.bag);
      }
    }
    // Else add the bad to the empty array
    else {
      localStore.push(this.bag);
    }

    // Set the localSrorage
    localStorage.setItem("bundleBuilder", JSON.stringify(localStore));
  }

  updateLocalStoreProperty(property, value) {
    const localStore = this.getLocalStorage();
    localStore[this.getBagId()][property] = value;
    localStorage.setItem("bundleBuilder", JSON.stringify(localStore));
  }

  updateTotals() {
    this.bag.subtotal = this.bag.items.reduce(
      (acc, { price }) => acc + price,
      0
    );

    const footer = this.querySelector(".js-bundle-builder__footer");
    const quantityElement = footer.querySelector("[data-quantity]");
    const subtotalElement = footer.querySelector("[data-subtotal]");
    const modalSubtotal = this.querySelector(".js-bundle-builder__modal-total");
    const currencyElement = footer.querySelector("[data-currency]");
    const totalsTextElement = footer.querySelector("[data-totals-text]");
    const itemsText = this.bag.quantity === 1 ? "item" : "items";

    totalsTextElement.textContent = itemsText;

    quantityElement.textContent = this.bag.quantity;
    subtotalElement.textContent = this.bag.subtotal;
    if (modalSubtotal) modalSubtotal.textContent = this.bag.subtotal;
    this.elements.modalNextButton.textContent = this.bag.subtotal;

    let textContent = "";
    if (this.options.minItems > this.bag.quantity) {
      this.elements.addToCartButton.setAttribute("aria-disabled", true);
      this.elements.modalNextButton.setAttribute("aria-disabled", true);
      this.elements.addToCartButton.style.pointerEvents = "none";
      this.elements.modalNextButton.style.pointerEvents = "none";
      const remainingItems = this.options.minItems - this.bag.quantity;
      const itemString = remainingItems === 1 ? "item" : "items";
      textContent = `Add ${remainingItems} ${itemString} ${this.strings.toContinue}`;
    } else {
      this.elements.addToCartButton.setAttribute("aria-disabled", false);
      this.elements.modalNextButton.setAttribute("aria-disabled", false);
      this.elements.addToCartButton.style.pointerEvents = "auto";
      this.elements.modalNextButton.style.pointerEvents = "auto";
      this.bag.isSavedBag
        ? (textContent = this.strings.updateCartText)
        : (textContent = this.strings.addToCartText);
    }
    this.elements.addToCartButton.textContent = textContent;
    this.elements.modalSubmitButton.textContent = textContent;
    this.elements.modalNextButton.textContent = textContent;
    currencyElement.textContent = this.getCurrencySymbol();
  }
}

customElements.define("bundle-builder", BundleBuilder);
